import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=5586ba1c&"
import script from "./HowWorks.vue?vue&type=script&lang=js&"
export * from "./HowWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5586ba1c', component.options)
    } else {
      api.reload('5586ba1c', component.options)
    }
    module.hot.accept("./HowWorks.vue?vue&type=template&id=5586ba1c&", function () {
      api.rerender('5586ba1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/HowWorks.vue"
export default component.exports